import { GET } from '../api/apiHandler';
import { API_BASE_URL } from '../globals';
import { CAPABILITIES_FETCH } from '../api/routes';

export const getCapabilities = async (): Promise<string[] | null> => {
  const result = await GET(`${API_BASE_URL}${CAPABILITIES_FETCH}`);
  if (!result || result?.isSuccess === false) {
    return null;
  }
  return result?.data?.permissions ?? result?.response?.permissions ?? [];
};
